import { Observable } from "rxjs";
import { UserInfo } from "./models";

export abstract class UserInfoService {
  abstract getUser(): Observable<UserInfo>;
}
